import React from 'react';
import {
    AutoComplete,
    Button,
    Card,
    Col,
    DatePicker,
    Form,
    Icon,
    Input,
    message,
    Row,
    Select,
    Spin,
    Tooltip
} from 'antd';
import CkInfoItem from "../../components/CkInfoItem";
import { fetchEvt } from "../../redux/actions/evt";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { inEditMode } from "../../redux/actions/global";
import { patchEventHeader } from "../../services/evt";
import EvtSummaryEditor from "../../components/EvtSummaryEditor";



const { TextArea } = Input;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    const loginedUser = state.loginedUser;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});


class EvtViewBriefForm extends React.Component {
    constructor(props) {
        super(props);
        this.evtAddressMap = null;
        this.state = {
            formLoading: false,
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    intoEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, true)
    }
    cancelEdit = () => {
        this.props.editableChange(this.props.editableStatePropName, false)
        const evt = this.props.evt;
    }
    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true)
                var _values = { ...values };

                patchEventHeader(Object.assign({ id: this.props.evt.header.id, }, _values)).then(res => {
                    if (res.code == 200) {
                        message.info("更新成功!");
                        this.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading
            })
        }
    }



    render() {
        const evt = this.props.evt;

        const { getFieldDecorator, getFieldValue, getFieldError, setFieldsValue, getFieldsValue, setFieldsInitialValue } = this.props.form;


        const editableTools = this.props.editable ?
            <div className="evt-create-editable-tools">
                <Button type="primary" size="small" onClick={this.save}>保存</Button>
                <Button type="primary" size="small" ghost onClick={this.cancelEdit}>放弃</Button>
            </div>
            :
            <div className="evt-create-editable-tools" onClick={this.intoEdit}>
                <Button type="primary" size="small" ghost>编辑</Button>
            </div>


        return (
            <Form>
                <Spin spinning={this.state.formLoading}>
                    <Card bodyStyle={{ padding: "16px" }}>
                        {editableTools}
                        <CkInfoItem label={"活动详情文字"} contentStyle={{ whiteSpace: "normal" }}>
                            {
                                this.props.editable ?
                                    getFieldDecorator('summary', {
                                        initialValue: evt.header.summary,
                                        rules: [
                                            { type: "string", min: 2, max: 10000, message: '长度限制为2至10000个之间!' }
                                        ],
                                        getValueFromEvent: (raw) => raw

                                    })(
                                        <EvtSummaryEditor placeholder='活动详情文字。如需使用H5模板，希望文字分页，可使用上方的「分页符」，建议260字一页' />
                                    )
                                    :
                                    evt.header.summary
                            }
                        </CkInfoItem>
                    </Card>


                </Spin>
            </Form>
        )
    }
}


EvtViewBriefForm.contextTypes = {}

EvtViewBriefForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "baseAreaEditable",
    evtBaseAreaExtra: null,
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewBriefForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewBriefForm));


// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewBriefForm.jsx